import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Avatar, Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, View, Dimensions, Linking } from 'react-native';
import { useIsFocused } from "@react-navigation/native";
import { StatusBar } from 'expo-status-bar';
import Constants from "expo-constants"
import trackerApi from '../../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../../root.navigation.js';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

const CallIcon = (props) => (
  <Icon {...props}  name='phone-call'/>
);

export const SupervisorInfo = ({supervisor}) => {
  const isVisible = useIsFocused();
  // const { supervisor } = route.params;
  const [agent, setAgent] = useState({});
  console.log('su: ', supervisor);
  const getSubset = async() =>{
    const token =  await AsyncStorage.getItem('userId');
    if(supervisor != 'nobody'){
    const response = await trackerApi.post('/app/getSubsetProfile', {phone: supervisor}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) setAgent(response.data.agent[0])
    // else showMessage({
    //     message: `خطای دسترسی به دیتابیس`,
    //     type: "danger",
    //   });
  }
}

  React.useEffect(()=>{
    console.log('test refreshing!');
    getSubset();
  }, [isVisible, supervisor])

  const dial = ()=>{
    let phoneNumber = '';
    if (Platform.OS === 'android') { phoneNumber = `tel:${agent.phone}`; }
    else {phoneNumber = `telprompt:${agent.phone}`; }
    Linking.openURL(phoneNumber);
  }
  return (

      <Layout level='3' style={styles.container}>
      <View style={{alignItems:'center'}}>
      <Text status='primary' category='h6'>اطلاعات سوپروایزر</Text>
      { supervisor != 'nobody' ?
      <View style={{alignItems:'center'}}>
      <Avatar
        style={{ width:128,height:128, marginVertical:10, borderWidth:3, borderColor:'#134A93'}}
        source={{uri: `https://api.fntpf.ir/assets/uploaded/images/${agent && agent.img_uri ?  agent.img_uri : 'undefined.jpg'}`}}
        size='giant'
        />
        <Text>{agent && agent.firstname ? agent.firstname : ''} {agent && agent.lastname ? agent.lastname : ''}</Text>
        <Text appearance='hint'>شماره تماس: {agent && agent.phone ? agent.phone : ''}</Text>
        <View style={{alignItems:'flex-start' , marginHorizontal:10, width: width*0.7, marginTop:5}}>
        <Text status='primary' style={{marginTop: 10}}>استان {agent && agent.province ? agent.province : ''}، شهر {agent && agent.city ? agent.city : ''}</Text>
        <Text style={{marginTop: 10}}>آدرس: {agent && agent.work_address ? agent.work_address : ''}</Text>
        <Text style={{marginTop: 10}}>تلفن ثابت: {agent && agent.telephone ? agent.telephone : ''}</Text>
        </View>
        </View> :         <Text appearance='hint'>اطلاعات زیرمجموعه/ سوپروایزر برای شما ثبت نشده است</Text>

      }
        </View>
        <View style={{flexDirection:'row', marginTop: 30}}>
        <Button style={{borderRadius:10, marginBottom: 35, marginHorizontal:10, flex:1}} appearance='outline' onPress={()=> RootNavigation.navigate('profile')}>بازگشت</Button>
      { supervisor != 'nobody' &&
        <Button style={{borderRadius:10, marginBottom: 35, marginHorizontal:10, flex:3}} accessoryLeft={CallIcon}  onPress={dial}>تماس با سوپروایزر</Button>
}

        </View>
        <StatusBar backgroundColor='#134A93' style="light" />
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    alignItems:'center',
    justifyContent:'space-between',
    width: width*0.85,
    borderRadius: 10,
    borderWidth:1,
    borderColor:'#134A93'

  },
});
